import {
  ConfigurationIcon,
  CriticalItemIcon,
  DataUploadItem,
  DeliveryScheduleConfigurationIcon,
  FactoryIcon,
  FactoryManagerIcon,
  GeneralIcon,
  GeneralSettingsIcon,
  GestaoIMOIcon,
  GradeIcon,
  GroupUserIcon,
  IntegrationIcon,
  PermissionsProfileItem,
  RoundingUnit,
  SiloIcon,
  WalletIcon,
} from "components/icons/icn-index.icon";
import { ReleaseVersionIcon } from "components/icons/release-version.icn.icon";
import { white } from "material-ui/styles/colors";
import ActionShoppingCart from "material-ui/svg-icons/action/shopping-cart";
import NotificationsNone from "material-ui/svg-icons/social/notifications-none";
import PersonIcon from "material-ui/svg-icons/social/person";
import intl from "react-intl-universal";
import { profileAdmin } from "services/permissions/getPermissions";
import {
  isLoadCompositionFlowBrewerySide,
  usesReturnableAssets,
} from "utils/validations-general-settings";

export const getMenuList = (featureFlagLoadAndUnloadCapacityEnabled = false) => [
  {
    rota: "general",
    titulo: intl.get("master-data.menus.general"),
    icone: <GeneralIcon width="25px" height="25px" color={white} />,
    selecionado: true,
  },
  {
    rota: "budget-family",
    titulo: intl.get("master-data.menus.walletsAndFamilys"),
    icone: <WalletIcon color={white} />,
    selecionado: false,
  },
  {
    rota: "coordination-user",
    titulo: intl.get("master-data.menus.coordinationsAndUsers"),
    icone: <PersonIcon color={white} />,
    selecionado: false,
  },
  {
    rota: "supplier",
    titulo: intl.get("master-data.menus.providers"),
    icone: <GroupUserIcon color={white} />,
    selecionado: false,
  },
  {
    rota: "material",
    titulo: intl.get("master-data.menus.materials"),
    icone: <ActionShoppingCart color={white} />,
    selecionado: false,
  },
  {
    rota: "",
    titulo: intl.get("master-data.menus.managementUnitys"),
    icone: <FactoryManagerIcon color={white} />,
    selecionado: false,
    dataTestId: "master-data-menu-management-unities",
    subMenus: [
      {
        rota: "business-unit",
        titulo: intl.get("master-data.menus.submenus.unitys"),
        icone: <FactoryIcon color={white} />,
        selecionado: false,
        visivel: true,
      },
      {
        rota: featureFlagLoadAndUnloadCapacityEnabled
          ? "grid-parameterization"
          : "parametrizacao-grade",
        titulo: intl.get("master-data.menus.submenus.grid"),
        icone: <GradeIcon color={white} />,
        selecionado: false,
        visivel: true,
      },
      {
        rota: "silo-management",
        titulo: intl.get("master-data.menus.submenus.silo"),
        icone: <SiloIcon color={white} />,
        selecionado: false,
        visivel: false,
      },
      {
        rota: "delivery-schedule-configuration",
        titulo: intl.get("master-data.menus.submenus.deliverySchedule"),
        icone: <DeliveryScheduleConfigurationIcon />,
        selecionado: false,
        visivel: isLoadCompositionFlowBrewerySide(),
      },
    ],
  },
  {
    rota: "",
    titulo: intl.get("master-data.menus.configuration"),
    icone: <ConfigurationIcon color={white} />,
    selecionado: false,
    dataTestId: "master-data-menu-configuration",
    subMenus: [
      {
        rota: "general-settings",
        titulo: intl.get("master-data.menus.submenus.general-settings"),
        icone: <GeneralSettingsIcon />,
        selecionado: false,
        visivel: profileAdmin(),
      },
      {
        rota: "imo-management",
        titulo: intl.get("master-data.menus.submenus.gestao-imo"),
        icone: <GestaoIMOIcon color={white} />,
        selecionado: false,
        visivel: usesReturnableAssets(),
      },
      {
        rota: "configuracoes-integracoes",
        titulo: intl.get("master-data.menus.submenus.integrations"),
        icone: <IntegrationIcon color={white} />,
        selecionado: false,
        visivel: true,
      },
      {
        rota: "critical-items",
        titulo: intl.get("master-data.menus.submenus.critical-items"),
        icone: <CriticalItemIcon color={white} />,
        selecionado: false,
        visivel: true,
      },
      {
        rota: "unidades-arredondamento",
        titulo: intl.get("master-data.menus.submenus.roundingUnits"),
        icone: <RoundingUnit color={white} />,
        selecionado: false,
        visivel: true,
      },
      {
        rota: "data-upload",
        titulo: intl.get("master-data.menus.submenus.data-upload"),
        icone: <DataUploadItem color={white} />,
        selecionado: false,
        visivel: true,
        dataTestId: "master-data-menu-data-upload",
      },
      {
        rota: "release-version",
        titulo: intl.get("master-data.menus.submenus.versions"),
        icone: <ReleaseVersionIcon color={white} />,
        selecionado: false,
        visivel: true,
      },
      {
        rota: "permissions-settings",
        titulo: intl.get("master-data.menus.submenus.permission-setting"),
        icone: <PermissionsProfileItem color={white} />,
        selecionado: false,
        visivel: profileAdmin(),
      },
      {
        rota: "automation-notifications",
        titulo: intl.get("master-data.menus.submenus.masterdata-automation"),
        icone: <NotificationsNone color={white} />,
        selecionado: false,
        visivel: true,
      },
    ],
  },
];
